<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title class="body-2">
        <span class="headline">Request Subsequent Advance</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="hideDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-layout class="m-t-15">
        <v-flex lg3>
          <span class="subtitle-1">Payment Options</span>
          <div class="input-section">
            <template v-for="(field, index) of layout.setting.sectionB">
              <v-layout class="m-h-10" :key="assist.tool.getRandomKey(index)" row>
                <v-flex class="m-t-25 f-w-600" lg6>
                  <span>{{ field.label }}</span>
                </v-flex>
                <v-flex lg6 v-if="field.controlType === 'date'">
                  <arb-date-picker-menu
                    v-model="layout.inputData[field.fieldKey]"
                    :allowed="field.allowed"
                    :disabled="layout.datePicker"
                    @change="changeEventHandler"
                  ></arb-date-picker-menu>
                </v-flex>
                <v-flex lg6 v-if="field.controlType === 'select'">
                  <v-select
                    v-model="layout.inputData[field.fieldKey]"
                    :items="field.options[field.fieldKey]"
                    item-text="text"
                    item-value="value"
                    @change="changeEventHandler"
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex
                  class="input-slider"
                  lg10
                  v-if="field.controlType === 'slider'"
                >
                  <span class="input">$ {{ layout.inputData[field.fieldKey] }}</span>
                  <arb-slider-input
                    class="slider"
                    v-model="layout.inputData[field.fieldKey]"
                    :min="dataSource.multipleAdvanceRule.minimumAmount"
                    :max="dataSource.multipleAdvanceRule.maximumAmount"
                    :disabled="layout.sliderBtn"
                    @changeEventHandler="changeEventHandler"
                  ></arb-slider-input>
                </v-flex>
              </v-layout>
            </template>
          </div>
          <div>
            <span class="f-w-400">This is <b>{{ layout.nextAdvanceNumber }}</b> time to draw subsequent, details as below:</span>
            <template v-for="(field, index) of layout.setting.MultipleAdvanceRule">
              <v-layout :key="assist.tool.getRandomKey(index)">
                <v-flex  class="f-w-600" lg6>
                  <span>{{ field.label }}</span>
                </v-flex>
                <v-flex  class="text-right m-r-30 m-v-4" lg6>
                  <span>{{ assist.tool.fieldRender(dataSource.multipleAdvanceRule, field.template, field.format) }}</span>
                </v-flex>
              </v-layout>
            </template>
          </div>
        </v-flex>
        <v-divider vertical></v-divider>
        <v-flex lg9 class="m-l-15">
          <v-layout class="m-b-10" wrap>
            <v-flex lg4 class="text-left" v-for="(field, index) of layout.setting.sectionD" :key="assist.tool.getRandomKey(index)">
              <v-layout>
                <v-flex  class="f-w-600" lg6>
                  <span>{{ field.label }}</span>
                </v-flex>
                <v-flex lg6>
                  <span>{{ assist.tool.fieldRender(dataSource.creditInformation, field.template, field.format) }}</span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <arb-simple-table
            class="m-t-15 m-b-10"
            :desserts="dataSource.installments"
            :header="layout.setting.PAYMENT_SCHEDULE_TABLE"
            :height="layout.tableHeight"
            color="white"
          ></arb-simple-table>
          <v-divider></v-divider>
          <v-layout class="m-t-15" wrap>
            <v-flex class="text-left" v-for="(field, index) of layout.setting.sectionE" :key="assist.tool.getRandomKey(index)">
              <v-layout>
                <v-flex class="f-w-600" style="white-space: nowrap" lg6>
                  <span>{{ field.label }}</span>
                </v-flex>
                <v-flex lg6>
                  <span>{{ assist.tool.fieldRender(dataSource.creditInformation, field.template, field.format) }}</span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions class="pb-3">
      <v-spacer></v-spacer>
      <v-btn color="primary" :disabled="layout.enterBtn" @click="enterAction">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { Tool, DataType } from '@/util/index'
import { PPS_DIALOG_LAYOUT_SETTING } from '@/setting/layout/post-origination/dialog'
import { ProcessingApi } from '@/api/pandaria'
const tool = new Tool()
export default {
  name: 'RequestDrawCreditDialog',
  props: {
    loan: {
      type: Object
    },
    effectiveDate: String
  },
  data () {
    return {
      assist: {
        tool: tool
      },
      layout: {
        setting: PPS_DIALOG_LAYOUT_SETTING.DRAW_CREDIT,
        tableHeight: 300,
        inputData: {
          effectiveDate: this.effectiveDate,
          approvedAmount: 50,
          transactionMode: DataType.TransactionModeEnum.ACH.value
        },
        nextAdvanceNumber: this.store.getters.getPPSNextAdvanceNumber,
        calcedAdvance: false,
        sliderBtn: true,
        enterBtn: true,
        datePicker: true
      },
      dataSource: {
        interestRate: null,
        installments: [],
        creditInformation: {},
        multipleAdvanceRule: {
          stage: null,
          interestRate: null,
          maximumAmount: null,
          minimumAmount: null
        }
      }
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    },
    slaveLoanId () {
      return this.store.getters.getPPSFirstValidSlaveLoanId
    },
    isCalcAdvance () {
      return this.slaveLoanId && this.portfolioId
    },
    portfolioId () {
      if (tool.isNotEmpty(this.store.getters.getAccount.portfolioId)) {
        return this.store.getters.getAccount.portfolioId
      }
      return 8
    }
  },
  watch: {
    slaveLoanId: {
      handler: function () {
        if (this.isCalcAdvance) {
          this.calcAdvance()
        }
      },
      deep: true
    }
  },
  created () {
    this.calcAdvance()
  },
  methods: {
    hideDialog () {
      this.clearDialogData()
      this.$emit('hideDialog', 'REQUEST_DRAW_CREDIT')
    },
    enterAction () {
      this.$swal({
        type: 'question',
        text: 'Are you sure ?'
      }).then(select => {
        if (select.value) {
          this.createSlaveLoan()
          this.clearDialogData()
          this.$emit('hideDialog', 'REQUEST_DRAW_CREDIT')
        }
      })
    },
    changeEventHandler () {
      if (this.layout.calcedAdvance) {
        this.drawSubsequentAdvance()
      }
    },
    async calcAdvance () {
      const $this = this
      let loanId = this.slaveLoanId
      if (tool.isEmpty(loanId)) {
        loanId = this.store.getters.getPPSLatestAppId
      }
      const input = {
        loanId: loanId,
        portfolioId: this.portfolioId
      }
      await ProcessingApi.listLoanDetailsAdvance(input, function (data) {
        $this.layout.enterBtn = true
        $this.layout.sliderBtn = false
        $this.layout.datePicker = false
        $this.dataSource.multipleAdvanceRule = data
        $this.dataSource.interestRate = data.interestRate
        $this.layout.inputData.approvedAmount = data.minimumAmount || 50
        $this.drawSubsequentAdvance()
      },
      function (err) {
        $this.layout.enterBtn = true
        $this.layout.sliderBtn = true
        $this.layout.datePicker = true
        $this.clearDialogData()
        window._VMA.$emit('SHOW_SNACKBAR', { text: err.message, color: 'error' })
      })
    },
    async drawSubsequentAdvance () {
      const $this = this
      const input = {
        parentLoanId: this.loanId,
        effectiveDate: this.layout.inputData.effectiveDate,
        transactionMode: this.layout.inputData.transactionMode,
        approveAmount: this.layout.inputData.approvedAmount,
        interestRate: this.dataSource.interestRate,
        portfolioId: this.portfolioId,
        action: DataType.MultiActionRequestEnum.PREVIEW.value
      }
      await ProcessingApi.drawSubsequentAdvance(input, function (data) {
        $this.layout.calcedAdvance = true
        $this.layout.enterBtn = false
        $this.dataSource.creditInformation = data
        $this.dataSource.installments = data.installmentDataList
      },
      function (err) {
        $this.layout.calcedAdvance = true
        $this.layout.enterBtn = true
        window._VMA.$emit('SHOW_SNACKBAR', { text: err.message, color: 'error' })
      })
    },
    async createSlaveLoan () {
      const $this = this
      const input = {
        parentLoanId: this.loanId,
        effectiveDate: this.layout.inputData.effectiveDate,
        transactionMode: this.layout.inputData.transactionMode,
        approveAmount: this.layout.inputData.approvedAmount,
        interestRate: this.dataSource.interestRate,
        portfolioId: this.portfolioId,
        action: DataType.MultiActionRequestEnum.SAVE.value
      }
      await ProcessingApi.drawSubsequentAdvance(input, function () {
        if ($this.$route.path.includes('/collection/application/')) {
          $this.$router.push({ path: '/post-origination/application/' + $this.$route.params.uuid })
        } else {
          $this.$eventBus.$emit('get-latest-slave-detail-event', 'update loan history')
        }
      },
      function (data) {
        $this.layout.enterBtn = true
        $this.$popWarningAlert({ text: 'CreateSlaveLoan - ' + data.message })
      })
    },
    clearDialogData () {
      this.dataSource.installments = []
      this.dataSource.creditInformation = {}
      this.dataSource.multipleAdvanceRule.stage = null
      this.dataSource.multipleAdvanceRule.interestRate = null
      this.dataSource.multipleAdvanceRule.maximumAmount = null
      this.dataSource.multipleAdvanceRule.minimumAmount = null
      this.layout.inputData.approvedAmount = null
    }
  }
}
</script>
<style lang="scss" scoped>
.input-section {
  border: 1px solid;
  border-radius: 10px;
  margin: 20px 20px 20px 0;
  padding: 10px;
  height: 250px;
  .input-slider {
    text-align: center;
    margin-top: 65px;
    margin-left: 20px;
    position: absolute;
    top: auto;
    right: auto;
    .input {
      font-size: 30px;
    }
    .slider {
      width: 300px;
    }
  }
}
</style>
